import { render } from "./NewLine.vue?vue&type=template&id=08cc7fca&scoped=true"
import script from "./NewLine.vue?vue&type=script&lang=js"
export * from "./NewLine.vue?vue&type=script&lang=js"

import "./NewLine.vue?vue&type=style&index=0&id=08cc7fca&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cc7fca"]])

export default __exports__